import type { ContentApiImage } from '@libs/trip-planner-interfaces';

export const enum GalleryType {
  Masonry = 'masonry',
}
export interface ActivityDetailsGalleryData {
  images?: ContentApiImage[];
  productName: string | undefined;
  productCode: string | undefined;
}
